import { useChannelTalk } from '@repo/channel-talk';
import { useWindowOpen } from '@repo/platform';
import { Button, Description, Guide, Title } from '@zenterprise-inc/ui';
import { FC } from 'react';

import IllustChat from '@/assets/illust-icons/fill-balloon-chat-more-gy2.svg';
import IllustMoneyShield from '@/assets/illust-icons/illust-money-shield.svg';
import { SUPPORT_BOT_LINK, 비즈넵케어결제완료링크 } from '@/lib/constants/link';

interface Props {
  outStatCd: string;
}
type TrpTaxRefundSuccessContentProps = Props;

const TrpTaxRefundSuccessContent: FC<TrpTaxRefundSuccessContentProps> = ({ outStatCd }) => {
  const { openChannelTalk } = useChannelTalk();

  switch (outStatCd) {
    case '0031':
      return (
        <div className="flex h-[calc(100vh-100px)] grow items-center">
          <Description.Guide
            subTitle="결제 요청 중 문제가 발생했어요"
            description={'동일한 문제가 반복된다면\n고객센터로 문의해주세요.'}
            imgChild={<IllustChat width={80} height={80} />}
            button={{
              state: 'basic',
              onClick: () => {
                openChannelTalk(SUPPORT_BOT_LINK.errors);
              }
            }}
            buttonContent={'문의하기'}
          />
        </div>
      );

    default:
      return (
        <div className="page-padding">
          <Title.Section size="large" title="카드 결제가 완료되었어요!" subText={'비즈넵을 이용해주셔서 감사합니다.'} />
          <div className="mb-12" />
          <CareAdsCard />
        </div>
      );
  }
};

export default TrpTaxRefundSuccessContent;

const CareAdsCard = () => {
  const { openWindow } = useWindowOpen();

  const handleClick = () => {
    openWindow(비즈넵케어결제완료링크);
  };

  return (
    <Guide isCard className="bg-gray-50">
      <Guide.ImageArea>
        <IllustMoneyShield />
      </Guide.ImageArea>
      <Guide.TextArea>
        <Guide.Title>
          비즈넵 환급 고객님을 위한
          <br />
          빈틈없는 세무기장!
        </Guide.Title>
        <Guide.Description>
          절세혜택 걱정은 끝! 사장님은
          <br />더 중요한 사업에만 집중하세요
        </Guide.Description>
      </Guide.TextArea>
      <Guide.ButtonArea>
        <Button.Box size="default" state="primary" onClick={handleClick}>
          더 알아보기
        </Button.Box>
      </Guide.ButtonArea>
    </Guide>
  );
};
